<template>
  <order-details>
    <div class="col-12">
      <div class="page_title">
        確認送出報名表？
      </div>
    </div>
    <div class="col-12 mb-5">
      <h5>親愛的廠商您好：</h5>
      請仔細查看是否都已確認每一項報名活動，送出此報名表後將不再回到此活動報名流程，如果之後想要更改報名內容請至 企業專區做修改，謝謝！
    </div>
  </order-details>
</template>

<script>
import OrderDetails from '../common/OrderDetails'
export default {
  name: 'EnrollmentProcessOrderConfirmation',
  components: {
    OrderDetails
  }
}
</script>
